<template>
  <div class="filter-buttons">
    <RadioGroup
      class="filter-buttons__radio"
      :class="{ 'filter-buttons__radio_icon': isIconButtons }"
      :value="selectedFilter"
      :size="size"
      :optionType="ERadioButtonOptionType.button"
      @change="handleButtonClick"
    >
      <RadioButton
        v-for="filter in filters"
        :key="filter.key"
        :name="filter.key"
        :value="filter.key"
        :disabled="disabled"
      >
        <component
          :is="filter.icon"
          v-if="isIconButtons"
          class="filter-buttons__icon"
        />
        <template v-else>
          {{ filter.label }}
          <span v-if="filter.count">
            {{ filter.count }}
          </span>
        </template>
      </RadioButton>
    </RadioGroup>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { RadioButton, RadioGroup } from '@/ui';
import { TTableFilters } from '@/types';
import { ERadioButtonOptionType, ESize } from '@/ui/types';

export default defineComponent({
  name: 'FilterButtons',
  components: {
    RadioGroup,
    RadioButton,
  },
  props: {
    filters: {
      type: Array as PropType<TTableFilters>,
      default: () => [],
    },
    selectedFilter: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isIconButtons: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<ESize>,
      default: ESize.medium,
    },
  },
  emits: ['filterChange'],
  setup(_, { emit }) {
    const handleButtonClick = (event: any) => {
      emit('filterChange', event.target?.value);
    };

    return {
      ERadioButtonOptionType,

      handleButtonClick,
    };
  },
});
</script>
<style lang="scss" src="./styles.scss" />
